import { Contact } from 'store/vat-checker/models';
import { ExcelTransaction } from 'store/organisation/models';

type TransactionContactRef = Pick<
  ExcelTransaction,
  'contactId' | 'contactName' | 'contactHashRow'
>;

const normalizeKey = (value: string | null | undefined): string =>
  String(value ?? '').trim();

export const getContactLookupKeys = (contact: Contact): string[] => {
  const keys = [
    contact.contactUuid,
    contact.providerContactId,
    contact.name,
  ]
    .map(normalizeKey)
    .filter(Boolean);
  return [...new Set(keys)];
};

export const collectAssignedContactIdentifiersFromTransactions = (
  transactions: TransactionContactRef[] | null | undefined
): Set<string> => {
  const identifiers = new Set<string>();
  (transactions ?? []).forEach((transaction) => {
    [transaction.contactId, transaction.contactName, transaction.contactHashRow]
      .map(normalizeKey)
      .filter(Boolean)
      .forEach((key) => identifiers.add(key));
  });
  return identifiers;
};

export const isContactAssignedToTransactions = (
  contact: Contact,
  assignedIdentifiers: Set<string>
): boolean => {
  if (!assignedIdentifiers.size) return false;
  return getContactLookupKeys(contact).some((key) =>
    assignedIdentifiers.has(key)
  );
};

/** API filter bodies to check whether a contact is referenced by any transaction. */
export const buildContactUsageApiFilterAttempts = (
  contact: Contact
): Record<string, string[]>[] => {
  const keys = getContactLookupKeys(contact);
  const attempts: Record<string, string[]>[] = [];
  keys.forEach((key) => {
    attempts.push({ contactId: [key] });
    attempts.push({ contactName: [key] });
  });
  return attempts;
};
